import {forwardRef} from "react";
import {supplierApi} from "~/api";
import {DebounceSelect} from "../index";

const SelectSupplier = forwardRef(({ options, errors, ...props }, ref) =>
{
	const onSearchSupplier = async (keyword) =>
	{
		const response = await supplierApi.options({keyword, limit: 300});

		return response.data.map((supplier) => ({
			label: `${supplier.code} ${supplier.name}`,
			value: supplier.id,
		}))
	}

	return (
		<DebounceSelect fetchOptions={onSearchSupplier} errors={errors} optionsDefault={options} {...props}/>
	)
});

export default SelectSupplier;

